import { computed } from 'vue';
import { usePolicy } from './usePolicy';
import { REPORT_DOWNLOAD_BY_TYPE } from 'dashboard/constants/permissions';

export const REPORT_DOWNLOAD_ACCESS = permissionKey => [
  'administrator',
  'report_manage',
  permissionKey,
];

export function useCanDownloadReport(permissionKey) {
  const { checkPermissions } = usePolicy();
  return computed(() =>
    checkPermissions(REPORT_DOWNLOAD_ACCESS(permissionKey))
  );
}

export function useCanDownloadReportType(type) {
  return useCanDownloadReport(REPORT_DOWNLOAD_BY_TYPE[type]);
}
